<template>
	<div>
		<div :class="{'background-green' : active}" class="list-border">
			<div class="padding-16">
				<img class="who-text-margin" width="24" height="24" src="../../../../assets/images/icons/solid/automation_who.svg"/>
				<label :class="{'automation-group-title-color' : active}" class="automation-group-title ml-3 ">
					WHO
				</label>
				<div class="checkbox-container font-color-black font-16 font-gilroy font-weight-500">
						<input class="ml-3" type="checkbox" id="checkbox" v-model="all_employees">
						<label for="checkbox">All Employees</label>
				</div>
		
				<match-button-group v-if="filters && filters.filter_lines.length>1"
				@matchClicked="matchClickedGroup"
				:match_all="filters.logic">

				</match-button-group>
				
				<div  v-if="filters" class="padding-8-top" :class="[condition_connection_items, all_employees_selected]">
						
					<div v-for="(elem, index) in filters.filter_lines" :key="index">
						<div class="flex">
							<a class="pointer" @click="removeConditionWho(index)">
								<img v-if="condition_connectiion_remove" class="mt-2 mr-2" width="16" height="16" src="../../../../assets/images/icons/solid/automation_remove_circle.svg"/>
							</a>
							

							<condition-group-who
							:filter_updated="filter_updated"
							:filter_selection="elem"
							:edit="edit_view_"
						    @updateFilterWho="updateFilterWho"
							@addFilterAvailablity="addFilterAvailablity"
							:parent_index="index" :key="index"
							class="width-100" ></condition-group-who>
						</div>
						<connection-line v-if="condition_connection_line(index)" :connection_text="filters.logic"></connection-line>
					</div>

				</div>

				<section :class="{'input-disabled not-allowed': !add_filter_available || all_employees}" class="text-add-filter font-weight-500 font-gilroy font-16 pointer mt-2"> 
					<a  @click="addFilterWho()">
						<img class="" width="14" height="14" src="../../../../assets/images/icons/solid/automation_add_circle.svg"/>
					
					Add filter
					</a>
				</section>
			</div>
		</div>

	</div>
</template>
<script>
import conditionGroupWho from './conditionGroupWho.vue'
import matchButtonGroup from '../../automationSharedView/matchButtonGroup.vue'
import connectionLine from '../../automationSharedView/connectionLine.vue'
import { EventBus } from  '../../../../event_bus.js'
export default {
	props:{
		active:{
			active:{
				type: Boolean
			}
		},
		automation_edit_detail:{
			required: false
		},
		edit_view:{
			required: true
		}
	},
	components: {
		conditionGroupWho,
		connectionLine,
		matchButtonGroup
	},
	data : function(){
		return{
			all_employees: false,
			match_any: true,
			match_all: true,
			//filters: null,
			filters: {
				logic:'AND',
				filter_lines: [{ 
					conditions:{
						logic:"AND",
						condition_lines: []
					}
				}],
			},	
			add_filter_available: false,
			filter_updated: false,
			updatedAPIFilters_:[],
			edit_view_:false
		}
	},
	computed : {
		condition_connection_items: function(){
			if(this.filters.filter_lines.length > 1){
				return 'padding-left-8'
			}else{
				return ''
			}
		},
		condition_connectiion_remove: function(){
			return this.filters.filter_lines.length > 1
		},
		all_employees_selected: function(){
			if(this.all_employees){
				//this.filter_lines = [{rule_filter:{ index: 0}}]
				return 'input-disabled not-allowed'
			}else{
				return ''
			}
		},
		getEditValue: function(){
			this.edit_view_ = !this.edit_view_

			return this.automation_edit_detail
		},
		get_all_employees: function(){
			return this.all_employees
		}

	},
	beforeDestroy(){
		 this.$nextTick(() => {
			this.cleanMemory()
		})
	},
	watch:{
		get_all_employees(val){
			console.log(val)
			if(val){
				this.$emit('updateWHOcondition', val)
			}else{
				this.$emit('updateWHOcondition', this.add_filter_available)
			}
		},
		add_filter_available(val){
			this.$emit('updateWHOcondition', val)
		},
		all_employees(all_employees_chosen){
			if(all_employees_chosen){
				this.$emit('updateWhoAPI', {logic:'ALL', filter_lines: null})
			}else{
				if(this.filters == null && !this.edit_view){
					this.cleanMemory()
				}else{
					this.$emit('updateWhoAPI', this.filters)
				}
			}
		},
		// filters:{
		// 	handler(val){
		// 		if(!this.all_employees){
		// 	 		//this.$emit('updateWhoAPI', val)
		// 		}
		// 	},
		// 	deep: true
		// },
		edit_view(val){
			this.cleanMemory()			
			if(val){
				if(this.automation_edit_detail.filter_lines == null && this.edit_view){
					this.all_employees = true
				}else{
					this.filters = this.automation_edit_detail
					this.$store.commit('setCurrentFilter', this.automation_edit_detail)
					this.edit_view_ = !this.edit_view_
				}
			}else{
				this.cleanMemory()
			}
		},
		
	},
	created : function(){
	
	},
	
	methods : {
		matchClickedGroup(condition){
			switch (condition){
				case 'any':
					this.match_all = false
					this.filters.logic = 'OR'
					break;
				case 'all':
					this.match_all = true
					this.filters.logic = 'AND'
					break;
			}
			if(!this.all_employees){
				this.$emit('updateWhoAPI', this.filters)
			}
		},
		addFilterWho(){
		
			this.add_filter_available = false
			this.filters.filter_lines.push({ 
				conditions:{
					logic:"AND",
					condition_lines: [{
						rule_property_id: '',
						conditional_id: '',
						value:'',
						value_child:''
					}]
				}
			})
		},
		updateFilterWho(new_condition, index, logic_text){
			this.filters.filter_lines[index].conditions.condition_lines = new_condition
			this.filters.filter_lines[index].conditions.logic = logic_text
			if(this.all_employees){
				this.$emit('updateWhoAPI', {logic:'ALL', filter_lines: null})
			}else{
		 		this.$emit('updateWhoAPI', this.filters)
			}
		},
		removeConditionWho(index){
				this.$nextTick(() => {
					this.filters.filter_lines.splice(index,1)
					this.filter_updated = !this.filter_updated
					this.$forceUpdate()
					this.add_filter_available = true
			});
		},
		condition_connection_line(index){
			return (this.filters.filter_lines.length != index + 1)
		},
		addFilterAvailablity(availability){
			this.add_filter_available = availability
		},
		cleanMemory(){
			this.$store.commit('setCurrentFilter', {})
			this.filters = 	{
				logic:'AND',
				filter_lines: [{ 
					conditions:{
						logic:"AND",
						condition_lines: [{
						rule_property_id: '',
						conditional_id: '',
						value:'',
						value_child:''
					}]
					}
				}],
			}
		}
	}
	
}
</script>
<style src="../../automation.css">

</style>


// WEBPACK FOOTER //
// src/components/automation/automationGroups/WHO/automationWho.vue